export default __webpack_public_path__ + "static/media/Filter.f96da628.svg";